var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper store"},[_c('Alert'),_vm._v(" "),_c('Header'),_vm._v(" "),_c('div',{staticClass:"content"},[_vm._t("default")],2),_vm._v(" "),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }